import { useFrame, useThree } from "@react-three/fiber";
import { useScene } from "./SceneController";
import * as THREE from "three";


const cameraTargets = {

    hero: {
        position: new THREE.Vector3(0, 0, 8),
        lookAt: new THREE.Vector3(0, 0, 0),
        speed: 0.025,
    },

    problem: {
        position: new THREE.Vector3(0, 1, 10),
        lookAt: new THREE.Vector3(0, 0, 0),
        speed: 0.03,
    },

    control: {
        position: new THREE.Vector3(1.5, 0.8, 8),
        lookAt: new THREE.Vector3(0, 0, 0),
        speed: 0.035,
    },

    solution: {
        position: new THREE.Vector3(-1, 0.5, 6.5),
        lookAt: new THREE.Vector3(0, 0, 0),
        speed: 0.045,
    },

    transformation: {
        position: new THREE.Vector3(0, 0.8, 5.8),
        lookAt: new THREE.Vector3(0, 0, 0),
        speed: 0.05,
    },

    vision: {
        position: new THREE.Vector3(0, 1.5, 4.8),
        lookAt: new THREE.Vector3(0, 0, 0),
        speed: 0.06,
    },

    cta: {
        position: new THREE.Vector3(0, 0, 4),
        lookAt: new THREE.Vector3(0, 0, 0),
        speed: 0.07,
    },

};


export default function CameraRig() {

    const { camera } = useThree();

    const { sceneState } = useScene();


    const currentPosition = new THREE.Vector3();


    useFrame((state)=>{

        const target =
            cameraTargets[sceneState.section] ||
            cameraTargets.hero;


        const t = state.clock.elapsedTime;


        currentPosition.set(

            target.position.x +
            Math.sin(t * 0.3) * 0.08,

            target.position.y +
            Math.cos(t * 0.25) * 0.05,

            target.position.z

        );


        camera.position.lerp(
            currentPosition,
            target.speed
        );


        const focus = new THREE.Vector3(

            target.lookAt.x,

            target.lookAt.y +
            Math.sin(t * 0.2) * 0.05,

            target.lookAt.z

        );


        camera.lookAt(focus);

    });


    return null;
}